import { FC } from 'react';
import { MdErrorOutline } from 'react-icons/md';
import DsoModal from 'components/DSO/DsoModal/DsoModal';
import { Button } from 'components/core';
import { DEFAULT_COLORS } from 'components/core/colors';
import { useI18n } from 'contexts/i18n';
import { DsoCartErrorModalProps } from './DsoCartErrorModal.types';
import { getDsoCartErrorMessage } from './DsoCartErrorModal.helper';
import * as Styled from './DsoCartErrorModal.styles';

const DsoCartErrorModal: FC<DsoCartErrorModalProps> = ({
  isOpen,
  error,
  onClose,
}) => {
  const i18n = useI18n();

  if (!error) return null;

  const message = getDsoCartErrorMessage(error);

  return (
    <DsoModal
      isOpen={isOpen}
      centered
      size="md"
      dismissOnOverlayClick={false}
      showCloseButton
      onClose={onClose}
      icon={<MdErrorOutline size={24} color={DEFAULT_COLORS.error} />}
      title={i18n['Unable to Update Cart'] ?? 'Unable to Update Cart'}
      footer={
        <Styled.FooterWrapper>
          <Button
            variant="primary"
            size="lg"
            width="150px"
            onClick={onClose}
            testId="cart-error-modal-close-btn"
          >
            {i18n['Okay']}
          </Button>
        </Styled.FooterWrapper>
      }
    >
      <Styled.ErrorMessage data-testid="cart-error-modal-message">
        {message}
      </Styled.ErrorMessage>
    </DsoModal>
  );
};

export default DsoCartErrorModal;
